import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

export interface ITestDenomination {
  denomination: string;
  species_id: string;
  class_code: string[];
  breeder_ref: string;
  breeder_name: string;
  batch_name: string;
  user_remark: string;
  analysis_req: boolean;
  species_latin_name: string;
  test_id: string;
  test_status: number;
  test_date: number;
  test_response: string;
  request_advice_id: number;
  advice_cancel_date: number|null;
  advice_cancelled_by: string|null;
  advice_request_date: number|null;
  advice_requested_by: string|null;
  analysis_date: number|null;
  analysisby: string;
  contact_name: string;
  standard_advice: string;
  cpvo_advice: string[];
}

interface ITestDenominationsState {
  tests: ITestDenomination[]|[];
}

const initialState: ITestDenominationsState = {
  tests: []
};

const addTestDenomination = ( state: ITestDenominationsState, action: any ) => {
  return updateObject( state, { tests: state.tests.concat( {...action.test} ) } );
};

const removeTestDenominations = ( state: ITestDenominationsState, action: any ) => {
  const updatedTests = [...state.tests].filter(t => !action.test_ids.includes(t.test_id));
  return updateObject( state, { tests: updatedTests } );
};

const addMultipleTestDenominations = ( state: ITestDenominationsState, action: any ) => {
  return updateObject( state, { tests: state.tests.concat( action.tests ) } );
};

const refreshTestDenominations = ( state: ITestDenominationsState, action: any ) => {
  const updatedTests = [...state.tests];
  action.tests.forEach((test: any) => {
    const index = updatedTests.findIndex((t: any) => t.test_id === test.testid);
    if (index > -1) {
      updatedTests[index] = {
        ...updatedTests[index],
        ...test
      };
    }
  })
  return updateObject( state, { tests: updatedTests } );
};

const reqAdviceTestDenominations = ( state: ITestDenominationsState, action: any ) => {
  const updatedTests = [...state.tests];
  const index = updatedTests.findIndex((t: any) => t.test_id === action.test_id);
  if (index > -1) {
    updatedTests[index].request_advice_id = 2;
    updatedTests[index].advice_cancelled_by = null;
    updatedTests[index].advice_cancel_date = null;
    updatedTests[index].advice_requested_by = action.advice_requested_by
    updatedTests[index].advice_request_date = action.advice_request_date;
  }
  return updateObject( state, { tests: updatedTests } );
};

const reqAdviceCancelTestDenominations = ( state: ITestDenominationsState, action: any ) => {
  const updatedTests = [...state.tests];
  const index = updatedTests.findIndex((t: any) => t.test_id === action.test_id);
  if (index > -1) {
    updatedTests[index].request_advice_id = 1;
    updatedTests[index].advice_cancelled_by = action.advice_cancelled_by;
    updatedTests[index].advice_cancel_date = action.advice_cancel_date;
    updatedTests[index].advice_requested_by = null;
    updatedTests[index].advice_request_date = null;
  }
  return updateObject( state, { tests: updatedTests } );
};

const reducer = ( state = initialState, action: any ) => {
    switch ( action.type ) {
        case actionTypes.TEST_DENOMINATION_ADD: return addTestDenomination( state, action );
        case actionTypes.TEST_DENOMINATION_REMOVE: return removeTestDenominations( state, action );
        case actionTypes.TEST_DENOMINATION_ADD_MULTIPLE: return addMultipleTestDenominations( state, action );
        case actionTypes.TEST_DENOMINATION_REFRESH: return refreshTestDenominations( state, action );
        case actionTypes.TEST_DENOMINATION_REQ_ADVICE: return reqAdviceTestDenominations( state, action );
        case actionTypes.TEST_DENOMINATION_REQ_ADVICE_CANCEL: return reqAdviceCancelTestDenominations( state, action );
        default: return state;
    }
};

export default reducer;
